var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6665 37.5832H7.33317C5.3165 37.5832 3.6665 35.9332 3.6665 33.9165V10.0832C3.6665 8.0665 5.3165 6.4165 7.33317 6.4165H36.6665C38.6832 6.4165 40.3332 8.0665 40.3332 10.0832V33.9165C40.3332 35.9332 38.6832 37.5832 36.6665 37.5832Z",
    fill: "#F57C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0835 17.4165C33.6023 17.4165 34.8335 16.1853 34.8335 14.6665C34.8335 13.1477 33.6023 11.9165 32.0835 11.9165C30.5647 11.9165 29.3335 13.1477 29.3335 14.6665C29.3335 16.1853 30.5647 17.4165 32.0835 17.4165Z",
    fill: "#FFF9C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 14.6665L8.25 29.3332H28.4167L18.3333 14.6665Z",
    fill: "#942A09"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4168 20.1665L21.0835 29.3332H35.7502L28.4168 20.1665Z",
    fill: "#BF360C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImage);
export default __webpack_public_path__ + "static/media/IconImage.82d73b53ed0d99ccf6de5bc39b93729e.svg";
export { ForwardRef as ReactComponent };